import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoaderService } from 'src/app/services/ux/loader.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.scss']
})
export class LoginViewComponent implements OnInit {
  @Output() loginSuccess = new EventEmitter<any>();

  constructor(
    public theme: ThemeService,
    private authSv: AuthService,
    private loaderSv: LoaderService
  ) {
  }

  ngOnInit(): void {
  }

  async login(form) {
    const { email, password } = form.value;
    const promise = this.authSv.signInWithEmailAndPassword(email, password);
    const user = await this.loaderSv.loadPromise(promise);

    this.loginSuccess.emit(user);
  }

  async googleLogin() {
    const promise = this.authSv.signInWithProvider("google");
    const user = await this.loaderSv.loadPromise(promise);

    this.loginSuccess.emit(user);
  }
}
